import { useAdminNotifications } from './useAdminNotifications';
import type { User } from '@supabase/supabase-js';

export const useAuthNotifications = () => {
  const { createNotification } = useAdminNotifications();

  const notifyLogin = async (email: string, user: User) => {
    console.log('Criando notificação de login com usuário:', user);
    await createNotification({
      title: 'Login Realizado',
      message: `O utilizador ${email} iniciou sessão no sistema.`,
      type: 'info',
      link: '/admin/notifications',
      user_id: user.id
    });
  };

  const notifyLogout = async (email: string, user: User) => {
    console.log('Criando notificação de logout com usuário:', user);
    await createNotification({
      title: 'Logout Realizado',
      message: `O utilizador ${email} terminou a sessão no sistema.`,
      type: 'info',
      link: '/admin/notifications',
      user_id: user.id
    });
  };

  return {
    notifyLogin,
    notifyLogout
  };
}; 